import React, { useState } from 'react';
import { useGlobal } from '../context/GlobalContext';
import { Ubicacion } from '../types';
import { deleteUbicacion } from '../services/ubicaciones';
import UbicacionForm from '../components/UbicacionForm';
import DeleteWarning from '../components/DeleteWarning';
import '../styles/Ubicaciones.css';

const Ubicaciones: React.FC = () => {
    const { data, loading, reLoad } = useGlobal();
    const ubicaciones: Ubicacion[] = data?.ubicaciones || [];

    const [modalData, setModalData] = useState<any>(null); // { type: 'Agregar' | 'Editar' | 'Eliminar', item?: Ubicacion }
    const [modalOpen, setModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState<string>('');

    const handleClose = () => {
        setModalOpen(false);
        setModalData(null);
    };

    const handleSuccess = (msg: string) => {
        setAlertMessage(msg);
        handleClose();
        reLoad();
        setTimeout(() => setAlertMessage(''), 5000);
    };

    const handleAdd = () => {
        setModalData({ type: 'Agregar' });
        setModalOpen(true);
    };

    const handleEdit = (item: Ubicacion) => {
        setModalData({ type: 'Editar', item });
        setModalOpen(true);
    };

    const handleConfirmDelete = (item: Ubicacion) => {
        setModalData({ type: 'Eliminar', item });
        setModalOpen(true);
    };

    const handleDelete = async () => {
        if (modalData?.item) {
            try {
                await deleteUbicacion(modalData.item.id);
                handleSuccess("Ubicación eliminada correctamente");
            } catch (error: any) {
                handleSuccess('Error al eliminar, posiblemente tiene productos asociados');
            }
        }
    };

    return (
        <div className="ubicaciones-page">
            <h2 className="text-2xl font-bold mb-4">Gestión de Ubicaciones</h2>

            {alertMessage && (
                <div className={`alert ${alertMessage.includes('Error') ? 'alert-danger' : 'alert-success'}`}>
                    {alertMessage}
                </div>
            )}

            <button className="button primary mb-4" onClick={handleAdd} style={{ marginBottom: '20px' }}>
                + Nueva Ubicación
            </button>

            {loading ? <p>Cargando...</p> : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Zona</th>
                                <th>Descripción</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ubicaciones.map((u) => (
                                <tr key={u.id}>
                                    <td>{u.id}</td>
                                    <td>{u.nombre}</td>
                                    <td>{u.zona_abc || 'C'}</td>
                                    <td>{u.descripcion}</td>
                                    <td>
                                        <button className="button secondary small" onClick={() => handleEdit(u)}>Editar</button>
                                        <button className="button danger small" onClick={() => handleConfirmDelete(u)} style={{ marginLeft: '5px', backgroundColor: '#dc3545', color: 'white', border: 'none' }}>Eliminar</button>
                                    </td>
                                </tr>
                            ))}
                            {ubicaciones.length === 0 && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'center' }}>No hay ubicaciones registradas</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        {(modalData.type === 'Agregar' || modalData.type === 'Editar') && (
                            <UbicacionForm
                                onClose={handleClose}
                                onSuccess={handleSuccess}
                                itemData={modalData.item}
                            />
                        )}
                        {modalData.type === 'Eliminar' && (
                            <DeleteWarning
                                itemType="Ubicación"
                                itemName={modalData.item.nombre}
                                onCancel={handleClose}
                                onConfirm={handleDelete}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ubicaciones;
